import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { newsRPMInstanceCollection } from "#root/schema/platform/newsrpm-marketplace";
import PageLayout from "./layout";

const title = (
  <Fragment>
    NewsRPM Instances{" "}
    <Link className="button" to="/admin/platform/newsrpm-marketplace/instance/new">
      New Instance
    </Link>
  </Fragment>
);

export default function NewsRPMInstancePage(): ReactNode {
  return (
    <PageLayout title="NewsRPM Marketplace - Instances">
      <PaginatedList title={title} collection={newsRPMInstanceCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Instance ID</th>
              <th>Network Code</th>
              <th>URL</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ code, networkCode, uri }) => (
              <tr key={code}>
                <td>{code}</td>
                <td>{networkCode}</td>
                <td>{uri}</td>
                <td>
                  <Link to={`/admin/platform/newsrpm-marketplace/instance/${code}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
